import { useThemeStyle } from '@linqpal/common-frontend/src/hooks'

const container = { flex: 1, alignSelf: 'stretch' }
const containerCentered = { ...container, alignItems: 'center', alignContent: 'flex-start' }

const makeBaseLayoutStyle = (theme) => ({
  container,
  containerCentered,
  containerPage: {
    padding: theme.paddings.large,
  },
  minimized: {
    flex: undefined,
  },
  leftAligned: {
    alignItems: 'flex-start',
  },
  // TODO : Theme padding and margin.
  buttonDense: { marginVertical: 0, marginHorizontal: 4 },
  button: { padding: 10 },
})

export const useBaseLayoutStyle = () => useThemeStyle(makeBaseLayoutStyle)
